import React from 'react';
import { useRobloky } from '../../context/RoblokyContext';
import { Gamepad2, Bookmark, User as UserIcon } from 'lucide-react';

export const MobileNav: React.FC = () => {
  const { view, goHome, openSaved, openProfile, profile } = useRobloky();

  const item = (active: boolean) =>
    `relative flex flex-col items-center justify-center flex-1 h-full py-1 transition-all focus:outline-none ${
      active ? 'text-red-400' : 'text-slate-400'
    }`;

  return (
    <nav
      aria-label="Mobile navigation"
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-[#07090e]/95 backdrop-blur-2xl border-t border-white/10 pb-[env(safe-area-inset-bottom,4px)]"
    >
      <div className="flex items-center justify-around h-16 px-2 max-w-lg mx-auto">
        <button onClick={goHome} className={item(view.name === 'home' || view.name === 'game')}>
          {view.name !== 'saved' && view.name !== 'profile' && (
            <span className="absolute top-0 w-8 h-1 bg-gradient-to-r from-red-500 to-orange-500 rounded-full" />
          )}
          <Gamepad2 className="h-5 w-5" />
          <span className="text-[10px] font-mono mt-1">Games</span>
        </button>
        <button onClick={openSaved} className={item(view.name === 'saved')}>
          {view.name === 'saved' && (
            <span className="absolute top-0 w-8 h-1 bg-gradient-to-r from-red-500 to-orange-500 rounded-full" />
          )}
          <Bookmark className="h-5 w-5" />
          <span className="text-[10px] font-mono mt-1">Saved</span>
        </button>
        <button onClick={openProfile} className={item(view.name === 'profile')}>
          {view.name === 'profile' && (
            <span className="absolute top-0 w-8 h-1 bg-gradient-to-r from-red-500 to-orange-500 rounded-full" />
          )}
          {profile?.avatar ? (
            <img src={profile.avatar} alt="" className="h-5 w-5 rounded-full object-cover border border-white/20" />
          ) : (
            <UserIcon className="h-5 w-5" />
          )}
          <span className="text-[10px] font-mono mt-1">Profile</span>
        </button>
      </div>
    </nav>
  );
};
